export default function getResource(label, vars = []) {
    const resources = {
        emailAndMailPreferences: 'Email & Mail Preferences',
        communicationPreferences: 'Communication Preferences'
    };
    return resources[label];
}
